import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "i376172083__a" }, [
        _createElementVNode("rect", {
          width: "24",
          height: "24",
          rx: "0"
        })
      ])
    ], -1),
    _createElementVNode("g", { "clip-path": "url(#i376172083__a)" }, [
      _createElementVNode("path", {
        fill: "#743A3A",
        d: "M6.257 9.943a.645.645 0 0 0-.6-.429H.943c-.514 0-.6.257-.343.686l8.571 10.371c.6.772.858.6.515-.257L6.257 9.943Zm-.514-1.286c.257 0 .514-.171.6-.343L9.6 1.543c.086-.172 0-.343-.257-.343H6.686c-.515 0-1.115.343-1.372.686L.514 7.97c-.257.429-.085.686.343.686h4.886Zm1.886 0h8.742c.258 0 .343-.171.258-.343L13.37 1.543c-.085-.172-.342-.343-.6-.343h-1.457c-.257 0-.514.171-.6.343L7.371 8.314c-.085.172 0 .343.258.343Zm15.857-.686-4.8-6.171c-.257-.343-.943-.686-1.372-.686h-2.743c-.257 0-.342.172-.257.343l3.257 6.772c.086.171.343.342.6.342h4.972c.428.086.6-.171.343-.6Zm-6.857 1.543H7.543c-.257 0-.343.172-.257.429L11.4 22.37c.343.858.771.943 1.114 0l4.372-12.428c.085-.172-.086-.429-.257-.429Zm6.428 0h-4.714a.645.645 0 0 0-.6.429l-3.686 10.543c-.343.857-.086 1.028.514.257L23.23 10.2c.428-.343.257-.686-.172-.686Z"
      })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "brands"}) } }